import component from '@/mixins/component'

export default {
  name: 'after-cover-link',
  mixins: [component],
  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      }
    },
    title: {
      type: String,
      default: ''
    },
    preTitle: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    noWrap: {
      type: String,
      default: ''
    }
  }
}
